// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#chartjs-tooltip {\n    position: absolute;\n    top: 0;\n}\n\n.value_wr {\n    width: 450px;\n    margin-left: -225px;\n    text-align: center;\n    height: 42px;\n}\n\n.value_wr_right {\n    text-align: right;\n    margin-left: -450px;\n}\n\n.value_wr_left {\n    text-align: left;\n    margin-left: 0px;\n}\n\n.vl {\n    position: absolute;\n    width: 1px;\n    background-color: rgba(255, 255, 255, 0.5);\n}", ""]);
// Exports
module.exports = exports;
